"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/partnersSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode } from "react";

type PartnersSectionPartnerFoursItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/hospital/hospital-img-1.png" | "/Templates/Doccure/img/hospital/hospital-img-2.png" | "/Templates/Doccure/img/hospital/hospital-img-3.png" | "/Templates/Doccure/img/hospital/hospital-img-4.png" | "/Templates/Doccure/img/hospital/hospital-img-5.png" | "/Templates/Doccure/img/hospital/hospital-img-6.png" */
    src: string;
    /** Detected variants: "partner-item-four" */
    className?: string;
    /** Detected variants: "client logo" */
    alt?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeFourPartnersSectionGeneratedProps = {
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: PartnersSectionPartnerFoursItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    partnersSectionPartnerFours: PartnersSectionPartnerFoursItem[];
    partnersSectionPartnerFoursItemWrapper?: (item: PartnersSectionPartnerFoursItem, content: ReactNode) => ReactNode;
    partnersSectionPartnerFoursRenderer?: (defaultNode: ReactNode) => ReactNode;
    partnersSectionPartnerFoursImageVisible?: boolean;
    partnersSectionPartnerFoursImageRenderer?: (item: PartnersSectionPartnerFoursItem, defaultNode: ReactNode) => ReactNode;
    partnersSectionPartnerFoursImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: PartnersSectionPartnerFoursItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFourPartnersSectionGenerated: FC<HomeFourPartnersSectionGeneratedProps> = ({
    divImageWithBasePath0ImageProps,
    sectionDiv0Slider0SliderProps,
    partnersSectionPartnerFours,
    partnersSectionPartnerFoursItemWrapper,
    partnersSectionPartnerFoursRenderer,
    partnersSectionPartnerFoursImageVisible,
    partnersSectionPartnerFoursImageRenderer,
    partnersSectionPartnerFoursImageProps,
}) => {
    return (
        <section className="partner-section-four section pt-0">
            <div className="container">
                <Slider {...settings} className="partner-slider-four" {...(sectionDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        partnersSectionPartnerFours,
                        (item: PartnersSectionPartnerFoursItem) => (
                            <div className={item.className ?? "partner-item-four"} key={item.key}>
                                {renderItemNode(partnersSectionPartnerFoursImageVisible, partnersSectionPartnerFoursImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "client logo"} {...(typeof partnersSectionPartnerFoursImageProps === "function" ? partnersSectionPartnerFoursImageProps(item) : (partnersSectionPartnerFoursImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        ),
                        partnersSectionPartnerFoursItemWrapper,
                        partnersSectionPartnerFoursRenderer
                    )}
                </Slider>
            </div>
        </section>
    );
};

export default HomeFourPartnersSectionGenerated;
